export const ROLE_LIST_INITING             = 'ROLE_LIST_INITING'
export const ROLE_LIST_REQUESTING          = 'ROLE_LIST_REQUESTING'
export const ROLE_LIST_SUCCESS             = 'ROLE_LIST_SUCCESS'
export const ROLE_LIST_ERROR               = 'ROLE_LIST_ERROR'   

export const ROLE_DETAIL_INITING           = 'ROLE_DETAIL_INITING'
export const ROLE_DETAIL_REQUESTING        = 'ROLE_DETAIL_REQUESTING'
export const ROLE_DETAIL_SUCCESS           = 'ROLE_DETAIL_SUCCESS'
export const ROLE_DETAIL_ERROR             = 'ROLE_DETAIL_ERROR'   

export const MENU_LIST_REQUESTING          = 'MENU_LIST_REQUESTING'
export const MENU_LIST_SUCCESS             = 'MENU_LIST_SUCCESS'
export const MENU_LIST_ERROR               = 'MENU_LIST_ERROR'  

export const USERS_LIST_REQUESTING          = 'USERS_LIST_REQUESTING'
export const USERS_LIST_SUCCESS             = 'USERS_LIST_SUCCESS'
export const USERS_LIST_ERROR               = 'USERS_LIST_ERROR'  

export const ROLE_UPDATE_REQUESTING        = 'ROLE_UPDATE_REQUESTING'
export const ROLE_UPDATE_SUCCESS           = 'ROLE_UPDATE_SUCCESS'
export const ROLE_UPDATE_ERROR             = 'ROLE_UPDATE_ERROR'   

export const ROLE_DETAIL_API               = '/api/v1/role/roles_detail_by_id'  
export const ROLE_LIST_API                 = '/api/v1/role/roles_list_by_store' 
export const MENU_LIST_API                 = '/api/v1/menu/get_menu_of_store_id' 
export const USERS_LIST_API                = '/api/v1/users/get_list_by_quanly'   
export const ROLE_UPDATE_API               = '/api/v1/role/update_role_by_id'  


// WEBPACK FOOTER //
// ./src/views/Role/constants.js